import { useTranslations } from '@vocab/react';
import type { IconSvgProps } from 'src/components/common/Icons/types';

import translations from '../.vocab';

export const IconCertifiedSvg = ({ ...props }: IconSvgProps) => {
  const { t } = useTranslations(translations);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="1 0 12 12"
      focusable="false"
      fill="none"
      width={14}
      height={14}
      overflow="visible"
      {...props}
    >
      <title>{t('Verified Icon')}</title>
      <g>
        <path
          d="M7.003 13.4163C6.90378 13.4163 6.8104 13.393 6.71702 13.3405L1.4644 10.4238C1.27764 10.3188 1.16675 10.1263 1.16675 9.91635V4.08301C1.16675 3.87301 1.28347 3.67468 1.4644 3.57551L6.71702 0.658848C6.89211 0.559681 7.10805 0.559681 7.28314 0.658848L12.5358 3.57551C12.7225 3.68051 12.8334 3.87301 12.8334 4.08301V9.91635C12.8334 10.1263 12.7167 10.3247 12.5358 10.4238L7.28314 13.3405C7.1956 13.3872 7.09638 13.4163 6.99716 13.4163H7.003ZM2.334 9.57218L7.003 12.168L11.672 9.57218V4.42718L7.003 1.83135L2.334 4.42718V9.57218Z"
          fill="#2E3849"
        />
        <path
          d="M6.41663 8.75C6.26496 8.75 6.11913 8.69167 6.00246 8.58083L4.42163 7L5.24413 6.1775L6.4108 7.34417L8.74413 5.01083L9.56663 5.83333L6.81913 8.58083C6.70246 8.6975 6.55663 8.75 6.40496 8.75H6.41663Z"
          fill="#2E3849"
        />
      </g>
    </svg>
  );
};
